<template>
    <section>
        <div class="container">
            <h1 v-scroll-reveal.reset="{ delay: 250 }">Ini Halaman Daftar</h1>
            <p class="lead" v-scroll-reveal.reset="{ delay: 300 }">Sementara masih kosong karena sudah ngantuk</p>
        </div>
    </section>
</template>

<script>
export default {
    name: 'Daftar'
}
</script>